<template>
    <div class="container-fluid tabs-content">

        <div class="row">
            <div class="col-24 col-lg-12 mb-12 mb-lg-0">

                <h3 class="mb-4" v-if="employee.invited_at">Redigera personuppgifter</h3>
                <h3 class="mb-4" v-else>Ange personuppgifter</h3>

                <div class="custom-form-section">
                    <div class="custom-form-group" :key="field.id" v-for="field in dynamic_fields" v-if="field.type !== 'password'">
                        <input-text
                            :type="field.input_type"
                            :name="'dynamic_fields_data.'+field.id+'.value'"
                            :label="field.label"
                            :required="field.is_required"
                            v-model="dynamic_fields_data[field.id].value"
                            v-if="field.type !== 'workplace_id'"
                        />
                        <input-select
                            :name="'dynamic_fields_data.'+field.id+'.value'"
                            :label="field.label"
                            :required="field.is_required"
                            v-model="dynamic_fields_data[field.id].value"
                            :options="workplaces"
                            v-if="field.type === 'workplace_id'"
                        />
                    </div>
                </div>

                <div class="d-flex justify-content-start justify-content-xl-end">
                    <button class="btn btn-primary" :disabled="patcher.submitted" @click="patcherPatch()">
                        <span class="spinner-border spinner-border-sm me-1"></span>
                        <span v-if="employee.invited_at">Spara uppgifter</span>
                        <span v-else>Spara och bjud in</span>
                    </button>
                </div>

            </div>
            <div class="d-none d-xl-block col-xl-3">
            </div>
            <div class="col-24 col-lg-12 col-xl-9" v-if="employee.invited_at">
                <div class="row">
                    <div class="col-24 mb-12">
                        <h3>Inaktivera kontot</h3>
                        <p>Ett inaktiverat konto är spärrat och går inte att logga in med. Du kan återaktivera det här igen.</p>
                        <poster-button
                            btn-class="btn btn-info"
                            :url="'/data/employees/' + employee.id + '/disableAccount'"
                            @success="inactivateSuccess()"
                        >
                            <span v-if="employee.disabled_at">Återaktivera kontot</span>
                            <span v-else>Inaktivera kontot</span>
                        </poster-button>
                    </div>
                    <div class="col-24">
                        <h3>Radera kontot</h3>
                        <p>Ett raderat konto tas bort helt, och alla personuppgifter rensas.</p>
                        <poster-button
                            btn-class="btn btn-danger"
                            :url="'/data/employees/' + employee.id + '/deleteAccount'"
                            confirm="Vill du verkligen ta bort kontot? Det kan inte ångras."
                            @success="deleteSuccess()"
                        >
                            Radera kontot
                        </poster-button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import patcher from '../../../shared/mixins/patcher'
import employeeDynamicFields from '../../../shared/mixins/employee-dynamic-fields'

import PosterButton from '../../../shared/components/poster-button'

import jQuery from 'jquery'

export default {
    mixins: [
        patcher,
        employeeDynamicFields
    ],

    components: {
        PosterButton
    },

    props: {
        employee: {
            required: true
        },
        dynamic_fields: {
            required: true
        },
        workplaces: {
            required: true
        }
    },

    data () {
        return {

        }
    },

    created () {
        console.log('resetDynamicFieldData')
        this.resetDynamicFieldData()
    },

    computed: {
        patcherUrl () {
            return '/data/employees/' + this.employee.id
        },
        patcherData () {
            return {
                dynamic_fields_data: this.dynamic_fields_data
            }
        }
    },

    methods: {
        patcherSuccess () {
            this.$emit('close')
            bus.$emit(
                'notify',
                'Ändringarna har sparats'
            )
        },
        inactivateSuccess () {
            this.$emit('close')
            bus.$emit(
                'notify',
                'Kontot har inaktiverats'
            )
        },
        deleteSuccess () {
            this.$emit('close')
            bus.$emit(
                'notify',
                'Kontot och personuppgifterna har raderats'
            )
        }
    }
}

</script>
